import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import rootReducer from "./store"
import {configureStore} from "@reduxjs/toolkit";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={configureStore({
        reducer: rootReducer
    })}>
        <React.Fragment>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <App/>
            </BrowserRouter>
        </React.Fragment>
    </Provider>
);

reportWebVitals();